//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Report from './report';

export const FilterTraceability = createContext({});

export default function   Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[1] !== "traceability") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterTraceability.Provider value={{ filter, setFilter }}>
      <Route path="/traceability/traceability_production_daily_reports" exact component={Report} isPrivate/>
    </FilterTraceability.Provider>
  )
}